import { EventType } from './EventType';

export class ProcessItem {
    constructor(eventType: EventType, sequenceNr: number | null, eventCreated: boolean, allSeqFinished: boolean) {
        this.eventType = eventType;
        this.sequenceNr = sequenceNr;
        this.eventCreated = eventCreated;
        this.allSeqFinished = allSeqFinished;
    }
    eventType: EventType;
    sequenceNr: number | null;
    eventCreated: boolean;
    allSeqFinished: boolean;
}
